import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18next from 'i18next'
import { bindActionCreators } from 'redux'

import { getCertificateInfoSignature } from '../../actions/api'
import { setCertificateInfo } from '../../actions/localStates'

class CertificateInfoSignature extends Component {

  constructor(props) {
    super(props);

    this.state = {
      certificateInfo: null
    }
  }

  componentDidMount() {
    this.props.actions.getCertificateInfoSignature(this.props.connectionStatus.baseUrl)
    .then((response) => {
      this.props.actions.setCertificateInfo(response)
      this.setState({certificateInfo: response})
    });
    
  }

  formatDate(dateInString) {
      var localeDateOptions = {
          "day": "numeric",
          "month": "numeric",
          "year": "numeric",
          "hour": "2-digit",
          "minute": "2-digit",
          "second": "2-digit",
          "timeZoneName": "short"
      }

      return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
  }

  _renderCertInfo() {
    let certInfo = this.props.certificateInfo.ownerCertificateInfo.value
    let crtInfo = [];
    for (var i in certInfo) {
            if (certInfo[i].value != null) {
              crtInfo.push(<dt>{certInfo[i].description}</dt>, <dd>{certInfo[i].value}</dd>)
            }
        }
        return crtInfo;
  }

  _renderCertInfoExtensions() {
    let certExtension = this.props.certificateInfo.extensionsCertificateInfo.value.personalData.value
    let crtExtension = [];
    for (var i in certExtension) {
            if (certExtension[i].value != null) {
              crtExtension.push(<dt>{certExtension[i].description}</dt>, <dd>{certExtension[i].value}</dd>)
            }
        }
        return crtExtension;
  }

  _renderIssuerInfo() {
    let issuerInfo = this.props.certificateInfo.issuerCertificateInfo.value
    var extCertInfo = this.props.certificateInfo.extensionsCertificateInfo.value;
    var extPersonalData = extCertInfo.personalData.value;
    let isrInfo = [];
    for (var i in issuerInfo) {
        if (issuerInfo[i].value != null) {
          isrInfo.push(<dt>{issuerInfo[i].description}</dt>, <dd>{issuerInfo[i].value}</dd>)
        }
    }
    for (var j in extPersonalData) {
        if (j === "drfou" || j === "passport" || j === "eddrun" || j === "edrpou") {
            if (extPersonalData[j].value != null) {
              isrInfo.push(<dt>{extPersonalData[j].description}</dt>, <dd>{extPersonalData[j].value}</dd>)
            }
        }
    }
    return isrInfo;
  }

  _renderPublicKeyInfo() {
    let publicKeyInfo = this.props.certificateInfo.publicKeyCertificateInfo.value
    let pkInfo = [];
    for (var i in publicKeyInfo) {
            if (publicKeyInfo[i].value != null) {
              pkInfo.push(<dt>{publicKeyInfo[i].description}</dt>, <dd>{publicKeyInfo[i].value}</dd>)
            }
        }
        return pkInfo;
  }

  getBlobData() {
      var saveBlob = (function () {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          return function (blob, fileName) {
                
              var url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = fileName.lastIndexOf(".") < 2 ? fileName : fileName.substr(0, fileName.lastIndexOf("."));
              a.click();
              window.URL.revokeObjectURL(url);
          };
      }());

      saveBlob(this.state.blobData, this.state.fileForDecryptName);
  }

  render() {
    return (
      this.props.certificateInfo ?
        <div style={{paddingTop: "10px", paddingBottom: "10px"}}>
                  <div className="card">
                    <div className="card-body">
                      <dl className="dl-horizontal">
                        <dt>{this.props.certificateInfo.certificateSerialNumber.description}</dt>
                        <dd>{this.props.certificateInfo.certificateSerialNumber.value}</dd>
                        <dt>{this.props.certificateInfo.notBefore.description}</dt>
                        <dd>{this.props.certificateInfo.notBefore.value}</dd>
                        <dt>{this.props.certificateInfo.notAfter.description}</dt>
                        <dd>{this.props.certificateInfo.notAfter.value}</dd>
                        <dt>{this.props.certificateInfo.extensionsCertificateInfo.value.isReinforced.description}</dt>
                        <dd>{this.props.certificateInfo.extensionsCertificateInfo.value.isReinforced.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</dd>
                        </dl>
                      </div>
                  </div>
          <div className="card" style={{marginTop: "10px"}}>
            <div className="card-header">
              {i18next.t("cert:ownerInfoTitle" : "ownerInfoTitle")}
            </div>
            <div className="card-body">
              <dl className="dl-horizontal">
                  {
                    this._renderCertInfo()
                  }
                  </dl>
                </div>
            </div>
            <div className="card" style={{marginTop: "10px"}}>
            <div className="card-header">
              {i18next.t("cert:issuerInfoTitle" : "issuerInfoTitle")}
            </div>
              <div className="card-body">
              <dl className="dl-horizontal">
                {
                  this._renderIssuerInfo()
                }
                  </dl>
                </div>
            </div>
            <div className="card" style={{marginTop: "10px", marginBottom: "10px"}}>
            <div className="card-header">
              {i18next.t("cert:publicKeyInfoBodyListTitle" : "publicKeyInfoBodyListTitle")}
            </div>
              <div className="card-body">
              <dl className="dl-horizontal">
                {
                  this._renderPublicKeyInfo()
                }
                </dl>
              </div>
          </div>
        </div> : <div></div>
    );
  }
}

function mapStateToProps(state) {
    return {
        localesReducer: state.localesReducer,
        language: state.localesReducer.language,
        connectionStatus: state.connectionStatusReucer,
        certificateInfo: state.certificateInfo.certInfoSignature
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      getCertificateInfoSignature,
      setCertificateInfo
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CertificateInfoSignature);


// WEBPACK FOOTER //
// ./src/components/body/CertificateInfoSignature.js